import React, {useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
// import useFetchData from '../crud/useFetchData';
// import {proto,url} from '../Helpers/api';
import {get,groupBy,uniqBy,sortBy} from 'lodash-es';
// import Tabela from './Tabela';
import Seletor from '../App/Seletor';
import Dre from '../App/Dre'
// import DataTable from '../../Common/DataTable';
// import {formataMoeda} from '../../Helpers/money';
import {mesesExtenso} from '../Helpers/date';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';

export default function Page_Dre (props) {
  const { empresas } = props.data;
  const [ empresa, setEmpresa ] = useState(null);
  const [ mes, setMes ] = useState(null);
  const [ ano, setAno ] = useState("2018");
  const [ opt, setOpt ] = useState([]);
  useEffect(() => {
    setOpt(sortBy(empresas,'Apelido').map(e => {
      let label = e.Cidade ? ` - ${e.Cidade} ` : " "
      label = e.Apelido + label + `(${e.Codigo})`
      return { value: e.Codigo, label, sublabel: e.RazaoSocial }
    }).filter(e => e.value != 87)) //// REMOVE87
  }, [empresas])

  // const [ empresaId, setEmpresaId ] = useState(87)
  return (
    <>
    <div style={{display: "flex", marginBottom:"15px"}}>
      <div style={{ flex: 1}}>
        <Typography variant="display2" gutterBottom>DRE</Typography>
      </div>
      <div style={{ flex: 1 }}>
        <Seletor
          fullWidth
          label={"Empresa"}
          onChange={setEmpresa}
          value={empresa}
          placeholder="Selecione a empresa"
          suggestions={opt}
          />
      </div>
      <div style={{ flex: 1 }}>
      <FormControl>
          <InputLabel htmlFor="mes">Mês</InputLabel>
          <Select
            value={mes}
            onChange={e => setMes(e.target.value)}
            inputProps={{
              name: 'mes',
              id: 'mes',
            }}
          >
          {mesesExtenso.map((m,i) => (
            <MenuItem value={String(i+1)}>{m}</MenuItem>
          ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="mes">Ano</InputLabel>
          <Select
            value={ano}
            onChange={e => setAno(e.target.value)}
            inputProps={{
              name: 'ano',
              id: 'ano',
            }}
          >
          {["2018", "2017", "2016"].map((a,i) => (
            <MenuItem value={a}>{a}</MenuItem>
          ))}
          </Select>
        </FormControl>
      </div>
    </div>
    { empresa && 
      <Dre empresa={empresa} mes={mes} ano={ano} />
    }
    </>
  )
}